import axios, {AxiosRequestConfig} from "axios";

export class UserInfoUtils {

    /**
     * 会員情報（共通ID）を取得します。
     * @param callback 会員情報取得後に実行するコールバック関数（HTTPステータスコード、会員情報）
     */
    public static getUserInfo(callback: (status: number, userInfo: any) => void) {
        axios.get("/userinfo")
            .then(cb => {
                callback(cb.status, cb.data)
            })
            .catch(error => {
                const {
                    status,
                    statusText
                } = error.response;
                callback(status, null)
            });
    }

    /**
     * Apple連携ユーザの名前を取得します。
     * @param callback Apple連携ユーザの名前取得後に実行するコールバック関数（HTTPステータスコード、名前）
     */
    public static getAppleUserName(callback: (status: number, name: string) => void) {
        axios.get("/apple-user-name")
            .then(cb => {
                callback(cb.status, cb.data)
            })
            .catch(error => {
                const {
                    status,
                    statusText
                } = error.response;
                callback(status, null)
            });
    }
}